/*
 * Project: LegalPlace assistant
 * File: src/components/save_button2.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateMailFromInput } from '../redux/actions/account_settings';
import { buildQuery } from '../redux/actions/checkout_operations';
import { setAppState, LP_STATE_SAVE } from '../redux/actions/app_state';
import { _lp } from '../logic/wording';
import lpApp from '../app/lp_app';

class _SaveButton extends Component {
  constructor(props) {
    super(props);
    this.saveButtonClicked = this.saveButtonClicked.bind(this);
    this.closeButtonCallback = this.closeButtonCallback.bind(this);
    // here we launch the shit
    // initFirebaseSystem(this.props.testAndLoadData)
    this.state = {
      closed: false,
    };
  }

  closeButtonCallback() {
    this.setState({
      closed: !this.state.closed,
    });
  }

  saveButtonClicked() {
    if (this.props.contract_id === '') {
      this.props.pass0(this.props.mail);
    } else {
      lpApp.ops.slack.sendContinueMessage('save update');
      this.props.pass0(this.props.mail, true);
    }
  }

  // we can make the input disabled in :
  /**
     * = saved
     * = re-saved
     * = not-saved
     */
  render() {
    const stateDefault = (this.props.contract_id === '');
    const stateSaved = (!stateDefault) && !this.props.edited_doc;// and changed state
    const stateError = typeof this.props.error !== 'undefined';
    let height = this.state.closed ? 'auto' : 0;
    if (!this.props.is_mobile) height = 'auto';
    // console.log(this.props.is_checking)
    return (
      <a
        style={{ cursor: 'pointer' }}
        className={`doc-save btn-spinner${
          this.props.is_mobile ? ' wz-save-doc-mob visible-xs' : ' '
        }${stateSaved ? ' done' : ''
        }${stateError ? ' error' : ''
        }${this.props.is_checking ? ' checking' : ''}`}
        onClick={stateSaved ? () => {} : this.saveButtonClicked}
      >
        <i className="icn-save" />
        <span>
          {stateDefault ? _lp('Enregistrer et continuer plus tard')
            : stateSaved
              ? lpApp.references.customs.get('save_section_success_notif') === 'NONE' ? _lp('Votre document a été enregistré') : lpApp.references.customs.get('save_section_success_notif')
              : this.props.is_checking
                ? _lp('Enregistrement en cours...')
                : _lp('Enregistrer et continuer plus tard')}
        </span>

      </a>
    );
  }
}

const mapStateToProps = state => ({
  mail: state.account_settings.mail,
  options: state.output.o,
  choices: state.output.c,
  variables: state.output.v,
  contractName: state.contract.name,
  currentSection: state.contract.currentSection,
  contract_id: state.document_state.unique,
  edited_doc: state.account_settings.edited_doc,
  error: state.errors.components['save-mail'],
  is_checking: state.loading_details.checking,
});

const mapDispatchToProps = dispatch => ({
  updateMail: (mail) => {
    dispatch(updateMailFromInput(mail));
  },
  pass0: (mail, alreadySaved = false) => {
    // dispatch(buildQuery(mail, true))
    if (alreadySaved) {
      dispatch(buildQuery(true));
    } else {
      dispatch(setAppState(LP_STATE_SAVE));
    }
  },
});

const SaveButton = connect(mapStateToProps, mapDispatchToProps)(_SaveButton);

export default SaveButton;



// WEBPACK FOOTER //
// ./src/components/save_button2.js